import {
  Box,
  FormControl,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ChangeEvent, FC, RefObject } from 'react';
import {
  StyledImagePreviewBox,
  StyledUploadButton,
  StyledNoImageText,
} from '../StyledComponents/StyledImageUpload';

interface ImageUploadProps {
  imagePreview: string | ArrayBuffer | null;
  fileInputRef: RefObject<HTMLInputElement>;
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClick: () => void;
  buttonWidth?: string;
}

const ImageUpload: FC<ImageUploadProps> = ({
  imagePreview,
  fileInputRef,
  onFileChange,
  onClick,
  buttonWidth = '150px',
}) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <StyledImagePreviewBox smScreen={smScreen}>
        {imagePreview ? (
          <img src={imagePreview as string} alt="Preview" />
        ) : (
          <Typography sx={StyledNoImageText}>No Image</Typography>
        )}
      </StyledImagePreviewBox>

      <FormControl fullWidth>
        <StyledUploadButton
          className="btn-primary"
          type="button"
          onClick={onClick}
          buttonWidth={buttonWidth}
        >
          Upload New
        </StyledUploadButton>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={onFileChange}
          style={{ display: 'none' }}
        />
      </FormControl>
    </Box>
  );
};

export default ImageUpload;
